import React, { Component } from "react";

export default class Contact extends Component {
  render() {
    return (
      <div className="contact section" id="Contact">
        <div className="container">
          <div className="section-head">
            <h2 className="text-center">Contact</h2>
          </div>
          <form
            action={`https://formspree.io/f/xpzbjzvy`}
            name="contact"
            method="POST"
            data-netlify="true"
          >
            <div>
              <label>
                Nom: <input type="text" name="nom" required />
              </label>
            </div>
            <div>
              <label>
                Email: <input type="email" name="email" required />
              </label>
            </div>
            <div>
              <label>
                Message: <textarea name="message" required></textarea>
              </label>
            </div>
            <div>
              <button type="submit">Envoyer</button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
